import axios from 'axios';
import config from '@/vue-caas/config/config.js';
import {
  isEmptyProcessWindowList,
  changeProcessShareFlag,
  compareTableData,
} from '@/vue-caas/utils/process';

const baseURI = config.setupApiUrl;

const filterStoreModule = {
  // namespaced: false,

  state: {
    filterList: [],
    filterSelectBoxList: [],
    filterDetail: {},
    filterId: '',
    dataSet01Source: [],
    searchBy: {},
    filterChange: {},
  },
  mutations: {
    SET_STORE_FILTER_LIST(state, filterList) {
      if (
        JSON.stringify(state.dataSet01Source) !== JSON.stringify(filterList) &&
        !isEmptyProcessWindowList()
      ) {
        changeProcessShareFlag('FLT');
      }
      state.filterList = filterList;
      state.dataSet01Source = filterList;
    },
    SET_STORE_FILTER_SELECT_BOX_LIST(state, filterSelectBoxList) {
      state.filterChange = compareTableData(
        state.filterSelectBoxList,
        filterSelectBoxList,
        'fltrId'
      );
      state.filterSelectBoxList = filterSelectBoxList.map((item) => {
        return {
          ...item,
          text: item.fltrNm,
          value: item.fltrId,
        };
      });
    },
    SET_STORE_FILTER(state, filterDetail) {
      state.filterDetail = filterDetail;
    },
    SET_STORE_FILTER_ID(state, id) {
      state.filterId = id;
      if (!isEmptyProcessWindowList()) {
        changeProcessShareFlag('FLT');
      }
    },
    SET_STORE_SEARCH_FILTER(state, searchBy) {
      let datarows = state.dataSet01Source;
      state.searchBy = searchBy;
      let filterBy = state.searchBy;
      let listResult = [];
      if (filterBy != null) {
        let searchBy = filterBy.searchBy;
        let str = filterBy.str;
        if (str.trim() == '') {
          listResult = datarows;
        }
        listResult = datarows.filter((item) => {
          if (searchBy == 'all') {
            for (const prop in item) {
              if (typeof item[prop] == 'string') {
                let propValue = item[prop].toLowerCase();
                let queryValue = str.toLowerCase();
                if (propValue.includes(queryValue)) {
                  return true;
                }
              } else if (typeof item[prop] == 'number') {
                let propValue = item[prop].toString().toLowerCase();
                let queryValue = str.toLowerCase();
                if (propValue.includes(queryValue)) {
                  return true;
                }
              }
            }
          } else {
            if (typeof item[searchBy] == 'string') {
              let propValue = item[searchBy].toLowerCase();
              let queryValue = str.toLowerCase();
              if (propValue.includes(queryValue)) {
                return true;
              }
            } else if (typeof item[searchBy] == 'number') {
              let propValue = item[searchBy].toString().toLowerCase();
              let queryValue = str.toLowerCase();
              if (propValue.includes(queryValue)) {
                return true;
              }
            }
          }

          return false;
        });
      }
      state.filterList = listResult;
    },
  },
  actions: {
    getFilterList: async ({ commit }, params) => {
      await axios
        .post(baseURI + '/fltr/list', params)
        .then((response) => {
          commit('SET_STORE_FILTER_LIST', response.data);
        })
        .catch((ex) => {
          throw ex;
        });
    },
    setSearchFilter: async ({ commit }, searchBy) => {
      commit('SET_STORE_SEARCH_FILTER', searchBy);
    },
    // 2021.10.26 203728 SPKA-224 return data not save store
    getFilterSelectBoxList: async ({ commit }, params) => {
      await axios
        .post(baseURI + '/fltr/list', params)
        .then((response) => {
          commit('SET_STORE_FILTER_SELECT_BOX_LIST', response.data);
        })
        .catch((ex) => {
          throw ex;
        });
    },

    getFilterDetail: async ({ commit }, params) => {
      await axios
        .get(baseURI + `/fltr/dtl/${params}`, params)
        .then((response) => {
          commit('SET_STORE_FILTER', response.data);
        })
        .catch((ex) => {
          throw ex;
        });
    },

    duplicateCheckFilter: async ({ commit }, params) => {
      await axios
        .get(baseURI + `/fltr/check/${params}`, params)
        .then((response) => {
          // commit('SET_STORE_FILTER_ID', response.data);
        })
        .catch((ex) => {
          throw ex;
        });
    },

    insertFilter: async ({ commit }, params) => {
      await axios
        .post(baseURI + '/fltr/insert', params)
        .then((response) => {
          // alert(response.data);
          // commit('SET_STORE_FILTER_LIST', response.data);
        })
        .catch((ex) => {
          throw ex;
        });
    },

    insertFilterFromProcSetup: async ({ commit }, params) => {
      await axios
        .post(baseURI + '/fltr/insert', params)
        .then((response) => {
          commit('SET_STORE_FILTER_ID', response.data);
        })
        .catch((ex) => {
          throw ex;
        });
    },

    editFilter: async ({ commit }, params) => {
      await axios
        .post(baseURI + '/fltr/update', params)
        .then((response) => {
          // alert(response.data);
          // commit('SET_STORE_FILTER_LIST', response.data);
        })
        .catch((ex) => {
          throw ex;
        });
    },

    editFilterFromProcSetup: async ({ commit }, params) => {
      await axios
        .post(baseURI + '/fltr/update', params)
        .then((response) => {
          // alert(response.data);
          commit('SET_STORE_FILTER_ID', response.data);
        })
        .catch((ex) => {
          throw ex;
        });
    },

    deleteFilter: async ({ commit }, params) => {
      await axios
        .post(baseURI + '/fltr/delete', params)
        .then((response) => {
          // alert(response.data);
          // commit('SET_STORE_FILTER_LIST', response.data);
        })
        .catch((ex) => {
          throw ex;
        });
    },
  },
  getters: {
    filterList: (state) => state.filterList,
    filterSelectBoxList: (state) => state.filterSelectBoxList,
    filterDetail: (state) => state.filterDetail,
    filterId: (state) => state.filterId,
    filterChange: (state) => state.filterChange,
  },
};

export default filterStoreModule;
